import "./styles.less";

import React, { useEffect, useContext, useState, ChangeEvent } from "react";
import {
	setRecientLocations,
} from "../../../Components/Filters/KeywordLocation/web";
import { Button, Col, Form, Row, Typography } from "antd";
import { encodeHashUrl, isTemporal, showPropertyType } from "../../../Utils/Functions";

import { OperationType } from "../../../Components/Filters/OperationType/web";
import { PropertyType } from "../../../Components/Filters/PropertyType/web";
import { TemporalFilter } from "../../../Components/Filters/TemporalFilter/web";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import { useHomeFilters } from "./HomeFilters.hook";
import { useTheme } from "../../../Styles/ThemeHook";
import { useTemporalFilter } from "shared-components/Components/Filters/TemporalFilter/TemporalFilter.hook";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import Show from "src/Components/Show/web";
import { Modal } from "shared-components/Components/Modal/web";
import { fetchSearchResults } from "src/services/search";
import { firstLetterToUppercase, getFormattedFilters } from "src/utils/Functions";
import { LocationSearch } from "src/Components/Filters/LocationSearch/web";
import { useRouter } from "next/router";

export const HomeFilters = () => {
	const { filters, changeFilters, search, filtersTags, showFilter } = useHomeFilters();
	const { country_code, main_domain, translations } = useContext(ConfigStateContext);
	const { theme } = useTheme();
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [modalError, setModalError] = useState(false);
	const [searchByCode, setSearchByCode] = useState("");
	const screens = useBreakpoint();
	const router = useRouter();

	const doSearch = () => search.send({ variables: { params: getFormattedFilters(filters) } });

	const showOperationFilter = true;
	const showTemporalFilter = isTemporal(filters.operation_type_id) && country_code !== "CO";
	const showPropertyFilter = showPropertyType(filters.operation_type_id) || country_code === "CO";

	const { setShowSeasonInput, showSeasonInput } = useTemporalFilter();


	useEffect(() => {
		if (filters.estate_id != null || filters.searchstring != null || filters.maxPrice != null) {
			search.send({ variables: { params: filters } });
		}
	}, [filters.estate_id, filters.searchstring, filters.maxPrice]);

	useEffect(() => {
		if (search.response.data && !search.response.loading) {
			setRecientLocations(filtersTags.neighborhood_id, filtersTags.estate_id);
			router.push(
				{
					pathname: "/searchPage",
					query: { hashed: encodeHashUrl({ filters: filtersTags }) },
				},
				search.response.data.searchUrl.url
			);
		}
	}, [search.response]);

	const handleChangeSeason = show => {
		setShowSeasonInput(show);
	};

	const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
		const inputValue = event.target.value.replace(/\D/g, "");
		setSearchByCode(inputValue);
	};

	const getPropertyByCode = async ()=> {
		fetchSearchResults(
		{
			rows: 100,
			params: {
				id: searchByCode,
			},
			page: 1,
			source: 10,
		},
		main_domain
	)
		.then(res => {
			if (res?.property?.link) {
					window.location.href = res.property.link;
			} else {
				setModalError(true);
			}
		})
		.catch(e => {
			console.log(e);
			return { data: [], property: null };
		});
	}

	const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
		if (event.key === "Enter") {
			getPropertyByCode();
		}
	};

	return (
		<Form onFinish={doSearch} className="home-filters home-filters-IC">
			<Row
				justify={"center"}
				gutter={[
					{
						xs: theme.spacing.mdSpacing,
						sm: theme.spacing.mdSpacing,
						lg: 0,
					},
					{
						xs: theme.spacing.mdSpacing,
						sm: theme.spacing.mdSpacing,
						lg: theme.spacing.smSpacing,
					},
				]}>
				{/* OPERTATION TYPE FILTER */}
				{showOperationFilter && (
					<Col
						xs={showTemporalFilter ? 24 : 12/*  : filters.operation_type_id === 1 ? 12 : 24 */}
						sm={showTemporalFilter ? 24 : 12/*  : filters.operation_type_id === 1 ? 12 : 24 */}
						order={0}
						lg={22}>
						<OperationType
							filterChanged={changeFilters}
							selectedValue={filters?.operation_type_id}
							home
							inputType={screens.lg ? "buttons" : "select"}
							handleChangeSeason={handleChangeSeason}
							showSeasonInput={showSeasonInput}
							show={showFilter.operationType}
						/>
					</Col>
				)}

				{/* PROPERTY TYPE FILTER */}
				{showPropertyFilter && (
					<Col xs={12} sm={12} lg={6} className="big-input big-input--property-type" order={3}>
						<PropertyType filterChanged={changeFilters} borderRadio={true/* filters.operation_type_id===2 */} />
					</Col>
					
				)}
				
				{/* PROPERTY STATUS FILTER */}
				{/* {filters.operation_type_id=== 1 && (
					<Col xs={12} sm={12} lg={6} className="big-input" order={2}>
						<PropStates inputType="dropdown" />
					</Col>
				)} */}
					
				{/* TEMPORAL FILTER */}
				{showTemporalFilter && (
					<Col xs={24} sm={24} lg={10} className="big-input temporal-filter-container" order={4}>
						<TemporalFilter
							filterChanged={changeFilters}
							showSeasonInput={showSeasonInput}
							handleChangeSeason={handleChangeSeason}
							show
						/>
					</Col>
				)}
				
				<Col flex={"1"} className="big-input" order={5}>
					<Row gutter={0}>
						<LocationSearch showSearchBtn isFromHome />
					</Row>
					{country_code === 'CO' && (
						<Row gutter={0} justify="end">
							<button
								className="btn-secondary btn-secondary--bg"
								style={{
									marginTop: "16px"
								}}
								onClick={(e) => {
									e.preventDefault()
									setIsModalOpen(true)
								}}>
								{`Buscar por ${translations.codigo}`}
							</button>
							<Modal
								show={isModalOpen}
								title={`Buscar por ${translations.codigo}`}
								footer={
									<footer className="modal-footer-container">
										<Button
											className="btn-primary"
											disabled={!searchByCode}
											type="primary"
											style={{ color: searchByCode ? "#FFFFFF" : "" }}
											onClick={getPropertyByCode}>
											Buscar
										</Button>
										<Button
											className="btn-secondary"
											onClick={() => {
												setIsModalOpen(false);
												setModalError(false);
												setSearchByCode("");
											}}>
											Cancelar
										</Button>
									</footer>
								}
								onClose={() => setIsModalOpen(false)}>
								<Typography.Title className="home-description-modal" level={5}>
									{firstLetterToUppercase(translations.ingresa)} {translations.codigo} del inmueble que {translations.quieres} encontrar
								</Typography.Title>
								<input
									type="text"
									placeholder={`${firstLetterToUppercase(translations.codigo)} del inmueble`}
									className="search-departaments"
									onKeyDown={handleKeyDown}
									style={{ marginBottom: "4px" }}
									value={searchByCode}
									onChange={handleSearchChange}
								/>
								<Show when={modalError}>
									<Typography.Text
										style={{
											paddingLeft: "8px",
											color: "#EA3E4F",
											textAlign: "left",
										}}>
										Código incorrecto o no existe
									</Typography.Text>
								</Show>
							</Modal>
						</Row>
					)}
				</Col>
			</Row>
		</Form>
	);
};